import React, { useState } from 'react';
import Icon from "components/Icon";
import { Link } from "react-router-dom";
import formatTime from "utils/formatTime";
import { useUsersContext } from "context/usersContext";
import defaultPic from "../../assets/images/default_profile_image.jpeg";
import getProviderLogoCall from "../../utils/getProviderLogoCall"
import { Cookies } from 'react-cookie';
import jwt from 'jsonwebtoken'

function OptionsList({ options, onSelect }) {
	return (
	  <ul className="options-list">
		{options.map((option, index) => (
		  <li key={index} onClick={() => onSelect(option)}>
			{option.label}
		  </li>
		))}
	  </ul>
	);
  }
  

const Contact = ({ contact }) => {
	const { setUserAsUnread, setBotStatus } = useUsersContext();

	const [options, setOptions] = useState([
		{ label: 'open', value: 1 },
		{ label: 'pending', value: 2 },
		{ label: 'closed', value: 3 }
	  ]);

	const [showOptions, setShowOptions] = useState(false);
	const [selectedOption, setSelectedOption] = useState(null);
	const [closeButtonCliecked, setCloseButtonCliecked] = useState(false);
	

	const handleOptionSelect = (option) => {
		// do something with the selected option
		console.log(`Selected option: ${option.label} (${option.value})`);
		setSelectedOption(option);
		setShowOptions(false);
		setBotStatus(contact._id,option.value)
		
	  };

	const getLastMessage = () => {
		const messageDates = Object.keys(contact.messages);
		const recentMessageDate = messageDates[messageDates.length - 1];
		const messages = [...contact.messages[recentMessageDate]];
		const lastMessage = messages.pop();
		return lastMessage;
	};

	const lastMessage = getLastMessage(contact);

	const lastMessageStatus = (value) => {
		switch(value) {
		  case 'sent':
			return 'singleTick';
		case 'delivered':
			return 'doubleTick';
		case 'read':
			return 'doubleTick';
		  default:
			return 'undelivered';
		}
	  }

	return (
		<Link
			className="sidebar-contact"
			to={`/chat/${contact._id}`}
			onClick={() => setUserAsUnread(contact._id)}
		>
			<div className="sidebar-contact__avatar-wrapper">
				<img
					src={contact.profile_picture ? contact.profile_picture : defaultPic}
					alt={contact.name}
					className="avatar"
				/>
			</div>
			<div className="sidebar-contact__content">
				<div className="sidebar-contact__top-content">
					<h2 className="sidebar-contact__name">  {contact.name? contact.name : '0'+ contact.phone.replace(/\D/g, '').slice(-9) }</h2>
					<span className="sidebar-contact__time">
						{formatTime(lastMessage.createdAt)}
					</span>
				</div>
				<div className="sidebar-contact__bottom-content">
					<p className="sidebar-contact__message-wrapper">
						{lastMessage.status && (
							<Icon
								id={
									lastMessageStatus(lastMessage.status)
									// lastMessage.status === "sent" ? "singleTick" : "doubleTick"
								}
								aria-label={lastMessage.status}
								className={`sidebar-contact__message-icon ${
									lastMessage.status === "read"
										? "sidebar-contact__message-icon--blue"
										: ""
								}`}

						
							/>
						)}
						<span
							className={`sidebar-contact__message ${
								!!contact.unread ? "sidebar-contact__message--unread" : ""
							}`}
						>
							{contact?.typing ? <i> typing...</i> : lastMessage?.body}
						</span>
					</p>
					<div className="sidebar-contact__btn">
						{contact?.pinned && (
							<Icon id="pinned" className="sidebar-contact__icon" />
						)}
						{!!contact?.unread && (
							<span className="sidebar-contact__unread">{contact?.unread}</span>
						)}
						<button aria-label="sidebar-contact__btn" onClick={() => {
							setBotStatus(contact._id,3)
							setCloseButtonCliecked(true)
							}}>
							{!closeButtonCliecked ?
							<Icon
								id="closeButtonNotPressed"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>	: 
								<Icon
								id="closeButtonPressed"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>
							}
						</button>

						{/* <div className="sidebar-contact__btn"> */}
						{/* <button
							aria-label="sidebar-contact__btn"
							className="sidebar-contact__btn"
							onClick={() => setShowOptions(!showOptions)}
						>
							<Icon
							id="downArrow"
							className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>
						</button> */}
						{/* {showOptions && (
							<OptionsList options={options} onSelect={handleOptionSelect} />
						)}
						{selectedOption && (
							<p>{selectedOption.label}</p>
						)} */}
						{/* </div> */}
					</div>
				</div>
			</div>
		</Link>
	);
};

export default Contact;
